<template>
  <div>
    <nav aria-label="breadcrumb">
      <ol class="breadcrumb" style="border-radius:0"  v-if="!$route.params.guestId">
        <li class="breadcrumb-item">
          <router-link v-bind:to="'/' + $i18n.locale + '/' + property.slug + '/' + $t('bookings.url')">
            {{ $t('bookings.name') }}
          </router-link>
        </li>
        <li class="breadcrumb-item">
          <router-link v-bind:to="'/' + $i18n.locale + '/' + $t('bookings.url') + '/' + $route.params.bookingId">
            {{ $t('booking') }}
            {{booking.night.first | date}} - {{booking.night.last | checkOut}}
          </router-link>
        </li>
        <li class="breadcrumb-item active" aria-current="page">{{ $t('guest.create') }}</li>
      </ol>
      <ol class="breadcrumb" style="border-radius:0"  v-else>
        <li class="breadcrumb-item">
          <router-link v-bind:to="'/' + $i18n.locale + '/' + property.slug + '/' + $t('guests.url')">
            {{ $t('guests.name') }}
          </router-link>
        </li>
        <li class="breadcrumb-item" aria-current="page">{{ $t('guest.edit') }}</li>
      </ol>
    </nav>

    <div class="container-fluid">
      <header class="page header">
        <div class="content">
          <div class="row">
            <div class="col-md-6">
              <h1 class="display-4 mb-0 mt-4 d-flex justify-content-between">
                <span v-if="guest._id">
                  {{ $t('guest.edit') }}
                </span>
                <span v-else>
                  {{ $t('guest.create') }}
                </span>
                <span>
                  <button id="snap" v-on:click="camera.show=true" class="btn btn-success mr-2" v-if="!guest._id">
                    <i class="fa fa-camera" aria-hidden="true"></i>
                  </button>
                  <!--<button id="snap" v-on:click="video.show=true" class="btn btn-success">
                    <i class="fa fa-video" aria-hidden="true"></i>
                  </button>-->
                </span>
              </h1>
            </div>
          </div>
          <p class="lead text-muted">
            <span v-if="$route.params.guestId">{{$route.params.guestId}}</span>
            <span v-else>{{ $t('guest.create') }}</span>
          </p>
        </div>

      </header>
      <div class="content">
        <div class="row">
          <div class="col-md-6 border-right">
            <ValidationObserver v-slot="{ handleSubmit }" ref="form">
              <ul class="nav nav-tabs lead mb-4" v-if="mrz.image.back">
                <li class="nav-item">
                  <a class="nav-link" @click.prevent="setActive('fields')" :class="{ active: isActive('fields') }" href="#fields">{{ $t('fields') }}</a>
                </li>
                <li class="nav-item">
                  <a class="nav-link" @click.prevent="setActive('mrz')" :class="{ active: isActive('mrz') }" href="#mrz">MRZ</a>
                </li>
              </ul>
              <div class="tab-content py-3" id="myTabContent" :class="{ 'tab-content py-3': mrz.image.back  }">
                <div :class="{ 'active show': isActive('fields'), 'tab-pane fade': mrz.image.back }" id="fields">
                  <img v-if="mrz.image.front" class="img-fluid pb-3" v-bind:src="mrz.image.front" style="width:100%">
                  <form id="guestForm">
                    <h5>{{ $t('information.guest') }}</h5>
                    <Guest v-bind.sync="{guest: guest, changeDOB: changeDOB, report: report  }"></Guest>

                    <h5>{{ $t('information.stay') }}</h5>
                    <Stay v-bind.sync="{guest: guest, dates: dates, documents: documents, touristTaxes: touristTaxes, report: report }"></Stay>

                    <div class="d-flex justify-content-between w-100">
                      <div class="btn-group btn-group-justified d-flex w-100 pb-5 pt-4">
                        <button v-b-modal.confirmDeleteModal type="button" name="delete" class="btn btn-danger flex-grow-1" v-if="$route.params.guestId" :disabled="report && report.status == 1">{{ $t('delete') }}</button>
                        <button type="button" name="save" class="btn btn-primary flex-grow-1" @click="handleSubmit(submit)">{{ $t('save') }}</button>
                      </div>
                    </div>
                  </form>
                </div>
                <div class="tab-pane fade" :class="{ 'active show': isActive('mrz') }" id="mrz" v-if="mrz.image.back">
                  <MRZ v-bind.sync="{guest: guest, image: mrz.image, changeDOB: changeDOB, checkFields: checkFields, setActive: setActive }"></MRZ>
                </div>
              </div>
            </ValidationObserver>
          </div>



          <div class="col-md-6">
            <h5>
              <router-link v-bind:to="'/' + $i18n.locale + '/' + $t('bookings.url') + '/' + booking._id">
                {{ $t('booking') }}
              </router-link>
            </h5>
            <Booking v-bind.sync="{booking: booking}"></Booking>

            <br>
            <br>
            <h5>eTurizem</h5>
            <Report ref="report" v-bind:report.sync="report" v-bind.sync="{socket: socket, documents: documents, touristTaxes: touristTaxes, property: property, checkIn: guest.checkIn, checkOutDate: checkOutDate}"></Report>
          </div>
        </div>
      </div>

      <Camera v-if="camera.show" v-bind:failedFields.sync="failedFields" v-bind.sync="{guest: guest, camera: camera, changeDOB: changeDOB}"></Camera>
      <Video v-if="video.show" v-bind.sync="{guest: guest, camera: video, changeDOB: changeDOB}"></Video>
    </div>

    <ConfirmDelete ref="confirmDelete" v-bind.sync="{type: 'guest', delete: deleteGuest}"></ConfirmDelete>
  </div>
</template>

<script>
import Guest from './components/Guest';
import Stay from './components/Stay';
import Booking from './components/Booking';
import Report from './components/Report';
import Camera from './components/Camera';
import Video from './components/Video';
import MRZ from './components/MRZ';

import ConfirmDelete from '../partials/modals/ConfirmDelete.vue';

import moment from 'moment';

const timestamp = Date.now();

export default {
  name: 'CreateGuest',
  beforeRouteEnter(to, from, next) {
    next(vm => {
      if(from.name){
        vm.from = from.fullPath
      }
    });
  },
  computed: {
    dates: function(){
      return {
        checkIn: moment(this.guest.checkIn.date).toDate(),
        checkOut: moment(this.guest.checkOut.date).toDate()
      };
    }
  },
  components: {
    Guest, Stay, Booking, Report, Camera, Video, MRZ, ConfirmDelete
  },
  props: ['socket'],
  data: () => ({
    checkOutDate: "",
    report: {},
    from: "",
    activeItem: 'fields',
    failedFields: [],
    mrz: {
      image: {
        "back": "",
        "front": ""
      }
    },
    camera: {
      show: false
    },
    video: {
      show: false
    },
    property: {
      slug:"",
      time: {
        checkIn: '',
        checkOut: ''
      },
    },
    booking: {
      _id: "",
      status: "",
      room: {},
      night: {
        first: '',
        last: ''
      },
      numGuests: 1,
      referer: ""
    },
    guest: {
      name: {
        first: '',
        last: ''
      },
      dob: {
        day: '',
        month: '',
        year: ''
      },
      country: '',
      document: {
        number: '',
        type: ''
      },
      touristTax: '',
      checkIn: {
        date: '',
        time: ''
      },
      gender: "",
      checkOut: {
        date: '',
        time: ''
      },
      booking: {
        _id: ''
      }
    },
    documents: [],
    touristTaxes: []
  }),
  updated(){
    console.log("updating")
    this.checkFields(this.failedFields);
  },
  watch: {
    'camera.show': function(val){
      if(val == false){
        console.log("zapremo")
        this.checkFields(this.failedFields);
        //this.failedFields = [];
      }
    }
  },
  created(){
    this.touristTaxes = [
      { value: "0", text: "Polna turistična taksa" },
      { value: "1", text: "Oprostitev - otrok do 7. leta starosti" },
      { value: "2", text: "Oprostitev - zdravniška napotnica" },
      { value: "3", text: "Oprostitev - invalidnost, telesna okvara" },
      { value: "4", text: "Oprostitev - otrok s posebnimi potrebami" },
      { value: "5", text: "Oprostitev - vzgojno-izobraževalni program" },
      { value: "6", text: "Oprostitev - dijaki, študenti v domovih" },
      { value: "7", text: "Oprostitev - začasno delo nad 30 dni" },
      { value: "8", text: "Oprostitev - mednarodna pogodba" },
      { value: "9", text: "Oprostitev - planinski dom (člani PZS)" },
      { value: "10", text: "Oprostitev - predpis občine" },
      { value: "11", text: "Polovično plačilo (50%) - oseba od 7. do 18. leta starosti" },
      { value: "12", text: "Polovično plačilo (50%) - mladinska prenočišča IYHF (osebe od 18. do 30. leta)" },
      { value: "13", text: "Polovično plačilo (50%) - turisti v kampih" },
      { value: "14", text: "Polovično plačilo (50%) - predpis občine" },
      { value: "15", text: "Delno plačilo - predpis občine" },
      { value: "16", text: "Ni plačila - ni storitve prenočevanja (dnevni počitek, ipd)" },
      { value: "17", text: "Oprostitev - udeleženci letovanj preko društev v javnem interesu" },
      { value: "18", text: "Oprostitev - prostovoljci za odpravo elementarnih nesreč" },
      { value: "19", text: "Oprostitev - policisti v obdobju opravljanja nalog" }
    ];

    this.documents = [
      { value: "P", text: "Potni list" },
      { value: "I", text: "Osebna izkaznica" },
      { value: "F", text: "Obmejna prepustnica" },
      { value: "V", text: "Vozniško dovoljenje" },
      { value: "O", text: "Orožni list" },
      { value: "U", text: "Upravne listine" },
      { value: "H", text: "Potne listine po mednarodni pogodbi" },
      { value: "L", text: "Otroci, državljani RS, brez dokumenta" }
    ]
    if(this.$route.params.guestId){
      fetch(process.env.VUE_APP_API + '/guests/' + this.$route.params.guestId + '/mrz', {
        method: 'get',
        credentials: 'include',
        headers: {
          "Content-type": "application/json",
          "Accept": "application/json",
          "Accept-Charset": "utf-8",
          'CSRF-Token': this.$csrf
        }
      }).then(response => {
        return response.blob();
      }).then(response => {
        if(response.type == 'image/jpg'){
          this.mrz.image.back = URL.createObjectURL(response);
        }
      })

      fetch(process.env.VUE_APP_API + '/guests/' + this.$route.params.guestId + '/mrz?type=front', {
        method: 'get',
        credentials: 'include',
        headers: {
          "Content-type": "application/json",
          "Accept": "application/json",
          "Accept-Charset": "utf-8",
          'CSRF-Token': this.$csrf
        }
      }).then(response => {
        return response.blob();
      }).then(response => {
        if(response.type == 'image/jpg'){
          this.mrz.image.front = URL.createObjectURL(response);
        }
      })

      fetch(process.env.VUE_APP_API + '/guests/' + this.$route.params.guestId, {
        method: 'get',
        credentials: 'include',
        headers: {
          "Content-type": "application/json",
          "Accept": "application/json",
          "Accept-Charset": "utf-8",
          'CSRF-Token': this.$csrf
        }
      })
      .then(response => {
        return response.json();
      })
      .then(response => {
        if(!response.error){
          this.checkOutDate = response.checkOut.date + 'T' + response.checkOut.time;
          this.guest = response;
          this.loadBooking(response.booking._id);
        }
      })
    }else{
      this.loadBooking(this.$route.params.bookingId)
      .then(() => {
        if(!this.from) this.from = '/' + this.$i18n.locale + '/' + this.$t('bookings.url') + '/' + this.$route.params.bookingId;
      });
    }
  },
  filters: {
    date: function(date){
      if(!date) return '';
      return moment(date).format('DD/MM/YYYY');
    },
    checkOut: function(date){
      if(!date) return '';
      return moment(date).add(1, 'days').format('DD/MM/YYYY');
    },
  },
  methods: {
    isActive (menuItem) {
      return this.activeItem === menuItem
    },
    setActive (menuItem) {
      this.activeItem = menuItem
    },
    submit: function(status = null){
      let method;
      let action;
      let newCheckOutDate = this.guest.checkOut.date + 'T' + this.guest.checkOut.time;
      if(this.$route.params.guestId){
        method = 'put';
        action = '/guests/' + this.guest._id;
      }else{
        method = 'post';
        action = '/guests';
      }
      return fetch( process.env.VUE_APP_API + action, {
        method : method,
        credentials: 'include',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json',
          'CSRF-Token': this.$csrf
        },
        body: JSON.stringify(this.guest)
      })
      .then(response => response.json())
      .then(response => {
        if(!response.error){
          if(this.guest.checkIn.date + 'T' + this.guest.checkIn.time <= moment().format('YYYY-MM-DD[T]HH:mm:ss')){
            if((this.$store.state.newGuests.find(g => g._id == this.property._id) && !this.guest._id)
            || (this.report.status == 1 && this.report.casOdhoda == this.checkOutDate && this.report.casOdhoda != newCheckOutDate))
            {
              this.$store.state.newGuests.find(g => g._id == this.property._id).newGuests += 1;
              this.$store.commit('changeGuests', this.$store.state.newGuests.find(g => g._id == this.property._id));
            }else if(this.report.status == 1 && this.report.casOdhoda != this.checkOutDate && this.report.casOdhoda == newCheckOutDate){
              this.$store.state.newGuests.find(g => g._id == this.property._id).newGuests -= 1;
              this.$store.commit('changeGuests', this.$store.state.newGuests.find(g => g._id == this.property._id));
            }
          }

          this.checkOutDate = newCheckOutDate;

          const message = this.$route.params.guestId ?  'Updated' : 'Created';
          this.$parent.messages.push({
            type: "alert",
            status: 'success',
            message: 'Guest ' + message + ' Successfully',
            time: timestamp
          })
          this.$router.push(this.from);
        }else{
          if(response.error.status == 403){
            this.$parent.messages.push({
              type: "alert",
              status: 'danger',
              message: this.error.message,
              time: timestamp
            })
          }
          this.$refs.form.setErrors(response.error.messages);
        }
      });
    },
    deleteGuest: function(){
      //if(!confirm("Are you sure you want to delete guest?")) return;
      return fetch(process.env.VUE_APP_API + '/guests/' + this.$route.params.guestId, {
        method: 'delete',
        credentials: 'include',
        headers: {
          "Content-type": "application/json",
          "Accept": "application/json",
          "Accept-Charset": "utf-8",
          'CSRF-Token': this.$csrf
        }
      })
      .then(response => response.json())
      .then(response => {
        if(!response.error){
          if(this.guest.checkIn.date + 'T' + this.guest.checkIn.time <= moment().format('YYYY-MM-DD[T]HH:mm:ss') && this.$store.state.newGuests.find(g => g._id == this.property._id) && this.$refs.report.report.status != 1){
            this.$store.state.newGuests.find(g => g._id == this.property._id).newGuests -= 1;
            this.$store.commit('changeGuests', this.$store.state.newGuests.find(g => g._id == this.property._id))
          }
          this.$parent.messages.push({
            type: "alert",
            status: 'success',
            message: 'Guest Deleted Successfully',
            time: timestamp
          })
          this.$router.push(this.from);
        }else{
          this.$parent.messages.push({
            type: "alert",
            status: 'danger',
            message: response.error,
            time: timestamp
          })
        }
      });
    },
    loadBooking: function(_id){
      return fetch(process.env.VUE_APP_API + '/bookings/' + _id, {
        method: 'get',
        credentials: 'include',
        headers: {
          "Content-type": "application/json",
          "Accept": "application/json",
          "Accept-Charset": "utf-8",
          'CSRF-Token': this.$csrf
        }
      })
      .then(response => response.json())
      .then(response => {
        this.booking = response;
        this.property = this.$store.state.host.properties.find(p => p.rooms.find(r => r._id == response.room._id));
        if(!this.guest.booking._id) this.guest.booking._id = response._id;
        if(!this.guest.checkIn.date) this.guest.checkIn.date = this.booking.night.first;
        if(!this.guest.checkIn.time) this.guest.checkIn.time = this.property.time.checkIn;
        if(!this.guest.checkOut.date) this.guest.checkOut.date =  moment(this.booking.night.last).add(1, 'days').format("YYYY-MM-DD");
        if(!this.guest.checkOut.time) this.guest.checkOut.time = this.property.time.checkOut;
      });

    },
    changeDOB(){
      if(this.guest.dob.year){
        if(this.guest.dob.month){
          if(this.guest.dob.day){
            let date = moment(this.guest.dob.year + '-' + this.guest.dob.month + '-' + this.guest.dob.day, "YYYY-M-D").format("YYYY-MM-DD");
            if(date > moment().subtract(18, 'years').format('YYYY-MM-DD')){
              if(date > moment().subtract(7, 'years').format('YYYY-MM-DD')){
                //brez turistične otrok do 7
                this.guest.touristTax = "1";
              }else{
                //polovična otrok do 18
                this.guest.touristTax = "11";
              }
            }else{
              //polna
              this.guest.touristTax = "0";
            }
          }else if(this.guest.dob.year + this.guest.dob.month > moment().subtract(18, 'years').format('YYYYM')){
            if(this.guest.dob.year + this.guest.dob.month > moment().subtract(7, 'years').format("YYYYM")){
              //brez turistične takse
              this.guest.touristTax = "1";
            }else if(this.guest.dob.year + this.guest.dob.month < moment().subtract(7, 'years').format("YYYYM")){
              //polovična otrok do 18
              this.guest.touristTax = "11";
            }else{
              this.guest.touristTax = "";
            }
          }else if(this.guest.dob.year + this.guest.dob.month < moment().subtract(18, 'years').format('YYYYM')){
            this.guest.touristTax = "0";
          }else{

          }
        }else if(this.guest.dob.year > moment().subtract(18, 'years').format('YYYY')){
          if(this.guest.dob.year > moment().subtract(7, 'years').format("YYYY")){
            //brez turistične takse
            this.guest.touristTax = "1";
          }else if(this.guest.dob.year < moment().subtract(7, 'years').format("YYYY")){
            //polovična otrok do 18
            this.guest.touristTax = "11";
          }else{
            this.guest.touristTax = "";
          }
        }else if(this.guest.dob.year < moment().subtract(18, 'years').format('YYYY')){
          //polna
          this.guest.touristTax = "0";
        }else{
          this.guest.touristTax = "";
        }
      }else{
        this.guest.touristTax = "";
      }
    },
    checkFields(failed = []){
      this.$refs.form.reset();

      if(failed.length){
        this.$refs.form.setErrors({
          'gender': failed.includes("valid genre format") ? ["Neuspešna validacija spola."] : [],
          'name.first': failed.includes("final hash") ? ["Validacija kontrolnih številk v dokumentu neuspešna."] : [],
          'name.last': failed.includes("final hash") ? ["Validacija kontrolnih številk v dokumentu neuspešna."] : [],
          "dob.day": failed.includes("birth date") ||  failed.includes("birth date hash") ? ["Neuspešna validacija datuma rojstva."] : [],
          "dob.month": failed.includes("birth date") ||  failed.includes("birth date hash") ? ["Neuspešna validacija datuma rojstva."] : [],
          "dob.year": failed.includes("birth date") ||  failed.includes("birth date hash") ? ["Neuspešna validacija datuma rojstva."] : [],
          "country": failed.includes("valid nationality code") ? ["Neuspešna validacija državljanstva."] : [],
          "document.number": failed.includes("document number hash") ? ["Neuspešna validacija številke dokumenta."] : [],
          "document.type": failed.includes("document type format") ? ["Neuspešna validacija vrste dokumenta."] : [],
        });
      }
    }
  }
}
</script>

<i18n>
{
  "en": {
    "guests": {
      "name": "Guests"
    },
    "guest": {
      "create": "Create Guest",
      "edit": "Edit Guest",
      "url": "guest"
    },
    "fields": "Fields",
    "information": {
      "guest": "Guest Information",
      "stay": "Stay information"
    },
    "booking": "Booking",
    "bookings": {
      "name": "Bookings",
      "url": "bookings"
    },
    "save": "Save Guest",
    "delete": "Delete Guest"
  },
  "sl": {
    "guests": {
      "name": "Gostje",
      "url": "gostje"
    },
    "guest": {
      "create": "Ustvari gosta",
      "edit": "Uredi gosta"
    },
    "fields": "Polja",
    "information": {
      "guest": "Podatki gosta",
      "stay": "Podatki bivanja"
    },
    "booking": "Rezervacija",
    "bookings": {
      "name": "Rezervacije",
      "url": "rezervacije"
    },
    "save": "Shrani gosta",
    "delete": "Pobriši gosta"
  }
}
</i18n>
